import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export default function Modal({
  open,
  title,
  onClose,
  children,
  footer,
  widthClass = 'max-w-5xl',
  heightClass = 'max-h-[85vh]',
  containerClassName,
  backdropClassName = 'bg-black/60 backdrop-blur-sm',
  showHeader = true,
  bodyClassName = 'p-5 overflow-y-auto flex-1 min-h-0',
  closeOnBackdropClick = true,
  showBackdrop = true,
}) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  if (!open || !mounted) return null;

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center isolate">
      {showBackdrop && (
        <div 
          className={`fixed inset-0 transition-opacity ${backdropClassName}`} 
          onClick={closeOnBackdropClick ? onClose : undefined} 
          aria-hidden="true"
        />
      )}

      {/* Modal Content */}
      <div
        className={
          containerClassName
            ? `${containerClassName} z-[10000]`
            : `relative bg-white dark:bg-gray-900 w-full ${widthClass} ${heightClass} rounded-xl shadow-2xl border border-gray-200 dark:border-gray-700 flex flex-col overflow-hidden transform transition-all z-[10000] mx-4`
        }
        role="dialog"
        aria-modal="true"
      >
        {showHeader && (
          <div className="px-5 py-4 border-b border-gray-200 dark:border-gray-700 flex items-center justify-between flex-shrink-0 bg-white dark:bg-gray-900 sticky top-0 z-10">
            {typeof title === 'string' ? (
              <h2 className="truncate text-lg font-semibold text-gray-900 dark:text-gray-100 pr-4">{title}</h2>
            ) : (
              <div className="min-w-0 flex-1 pr-4 text-lg font-semibold text-gray-900 dark:text-gray-100">
                {title}
              </div>
            )}
            <button
              onClick={onClose}
              className="inline-flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors flex-shrink-0"
              aria-label="Close"
            >
              <span className="text-xl leading-none">&times;</span>
            </button>
          </div>
        )}

        <div className={`${bodyClassName} bg-white dark:bg-gray-900`}>
          {children}
        </div>

        {footer !== undefined && (
          <div className="px-5 py-4 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 flex items-center gap-3 justify-end flex-shrink-0 sticky bottom-0 z-10">
            {footer}
          </div>
        )}
      </div>
    </div>,
    document.body
  );
}
